// extracted by mini-css-extract-plugin
export default {"tableResponsive":"HistorialConsumo_tableResponsive__V6i62"};